import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

export const THEME_PRIMARY_COLOR = '#384E89';
export const GRAY_ONE = '#828282';
export const GRAY_TWO = '#BDBDBD';
export const GRAY_THREE = '#F5F5F5';
export const THEME_WEBSITE_GREY_COLOR = '#8B8B8B';

const useStyles = makeStyles((theme) => ({
    showMoreCtaBox: {
        // width: 'calc(69% - 32px)',
        transform: 'translate(40vw, -15px)',
        // transform: 'translate(5.5%, -50%)',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '999'
    },
    textGrayOne: {
        color: `${GRAY_ONE}`,
        alignItems: 'left'
    },
    roomIconBox: {
        display: 'flex',
        justifyContent: 'end',
        width: '33%',
        maxWidth: '30px'
    },
    viewImageText: {
        marginTop: theme.spacing(1),
        color: THEME_PRIMARY_COLOR,
        fontWeight: '500',
        fontSize: '12px',
        cursor: 'pointer'
    },
    facilityGroupItem: {
        display: 'flex',
        alignItems: 'center',
        width: '50%'
    },
    offerContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    tableBorder: {
        borderRight: `0.5px solid ${GRAY_ONE}`
    },
    table: {
        backgroundColor: '#FFFFFF'
    },
    toolTipText: {
        color: '#FFFFFF !important',
        borderBottom: `0.5px solid ${GRAY_ONE} !important`
    },
    showMoreCta: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        color: theme.palette.primary.main,
        borderRadius: '24px',
        backgroundColor: GRAY_THREE,
        width: 'fit-content',
        padding: theme.spacing(0.8, 1.8),
        cursor: 'pointer',
        marginBottom: '5px'
    },

    selectRoomText: {
        fontSize: '14px',
        fontWeight: 700,
        color: THEME_PRIMARY_COLOR
    },
    submitQuoteDisclaimer: {
        fontWeight: 400,
        fontSize: '0.675rem'
    },
    actionText: {
        fontWeight: 500,
        color: theme.palette.primary.main,
        cursor: 'pointer',
        marginTop: theme.spacing(0.5),
        paddingRight: theme.spacing(2)
    },
    actionRemoveText: {
        fontWeight: 500,
        color: '#f44336',
        cursor: 'pointer',
        marginTop: theme.spacing(0.5),
        paddingRight: theme.spacing(2)
    },
    viewMore: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.mode === 'dark' ? '' : theme.palette.primary.main,
        fontWeight: 500,
        margin: theme.spacing(0.6),
        cursor: 'pointer'
    },
    clearFilter: {
        color: theme.palette.mode === 'dark' ? '' : theme.palette.primary.main,
        fontWeight: 500,
        margin: theme.spacing(0.6),
        cursor: 'pointer'
    },
    quotePreviewBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
    },
    quoteHeading: {
        fontSize: 24,
        fontWeight: 700
    },
    quoteDetailsCard: {
        width: '100%'
    },
    quoteAdditionalHeading: {
        fontWeight: 400
    },
    guestInfoIcon: {
        height: '20px',
        width: '20px'
    },
    guestInfoText: {
        fontSize: '14px',
        fontWeight: '400'
    },
    guestInfoHeading: {
        fontSize: '18px',
        fontWeight: '400'
    },
    iconBox: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
    },
    quoteInfoSubHeading: {
        fontSize: '14px',
        fontWeight: '500',
        padding: '8px 0'
    },
    quoteInfoBodyText: {
        fontSize: '14px',
        fontWeight: '400'
    },
    hotelDetailItem: {
        padding: '12px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    hotelFacilitiesBox: {
        display: 'flex',
        gap: '30px',
        padding: '18px 0 16px 0'
    },
    transfersItem: {
        padding: '16px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    quoteDetailsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '28px',
        width: '100%'
    },
    hotelDetailsModal: {
        width: '444px',
        maxHeight: '70vh',
        padding: '16px 16px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    shareWithAgentModal: {
        width: '444px',
        maxHeight: '70vh',
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    shareWithAgentModalForm: {
        width: '866px',
        padding: '0px 0px 16px 0px',
        display: 'flex',
        flexDirection: 'column'
    },
    primaryText: {
        fontSize: '14px',
        fontWeight: '500'
    },
    totalPriceInRowText: {
        fontWeight: '400'
    },
    divider: {
        borderColor: '#E3F2FD'
    },
    blackColor: {
        color: '#212121'
    },
    price: {
        fontSize: '20px',
        fontWeight: 500
    },
    priceBreakupTableFont: {
        fontSize: '12px'
    },
    daywiseCard: {
        padding: 0
    },
    daywiseContentClass: {
        padding: '12px 16px 12px'
    },
    paperBox: {
        height: 150
    },
    boxStyles: {
        gap: '20px'
    },
    userRatingText: {
        fontWeight: 500,
        fontSize: '18px',
        color: 'black'
    },
    hotelCardLocationText: {
        fontSize: '12px',
        fontWeight: 400,
        color: 'black'
    },
    // selectedFlightCard: {
    //     backgroundColor: '#F2F6FF !important' // '#F6F9FF'
    // },
    occupancyRoomBtn: {
        width: '25%',
        display: 'flex',
        padding: theme.spacing(0.5, 1),
        justifyContent: 'space-between',
        gap: '12px',
        backgroundColor: '#FFFFFF',
        boxShadow: '1px 3px 12px 0px #00000014',
        borderRadius: theme.spacing(1),
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            width: '50%'
        }
    },
    nonSelectedFlightCard: {
        // border: '1px solid red'
    },
    shadowCard: {
        backgroundColor: '#ffffff',
        boxShadow: '1px 3px 12px 0px #00000014',
        borderRadius: theme.spacing(1)
    },
    customisedTooltipWidth: {
        maxWidth: 'none',
        backgroundColor: 'rgba(33,33,33,0.9)',
        borderRadius: '8px'
    },
    // toolTipText: {
    //     color: '#FFFFFF !important',
    //     borderBottom: `0.5px solid ${grey} !important`
    // },
    // tableBorder: {
    //     borderRight: `0.5px solid ${grey}`
    // },
    cancelBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: 5,
        cursor: 'pointer'
    },
    titleClass: {
        color: theme.palette.grey.primary,
        gontWeight: 500
    },
    readMoreText: {
        color: theme.palette.primary.main,
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer'
    },
    dialogTitleClass: {
        paddingTop: '4px'
    },
    formButtonInput: {
        textTransform: 'none',
        fontWeight: '500',
        fontSize: '14px',
        width: '100%',
        color: theme.palette.grey[900],
        border: `1px solid rgba(0, 0, 0, 0.23)`,
        borderRadius: '8px',
        height: '50px',
        display: 'flex',
        justifyContent: 'start',
        paddingLeft: '14px',
        gap: '16px',
        background: 'white'
    },
    formButtonInputError: {
        textTransform: 'none',
        fontWeight: '500',
        fontSize: '14px',
        width: '100%',
        color: theme.palette.grey[900],
        border: `1px solid rgba(244, 67, 54, 1)`,
        borderRadius: '8px',
        height: '50px',
        display: 'flex',
        justifyContent: 'start',
        paddingLeft: '14px',
        gap: '16px',
        background: theme.palette.grey[50]
    },
    menuBox: {
        padding: theme.spacing(2)
    },
    greyText: {
        color: theme.palette.grey[500],
        fontWeight: 500,
        fontSize: '12px'
    },
    searchInputDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start'
        }
    },
    childAgeBox: {
        display: 'grid',
        gridTemplateRows: 'auto',
        gridTemplateAreas: "'childAge' 'childAge' 'childAge'",
        gridTemplateColumns: '28% 28% 28%',
        gridColumnGap: '20px'
    },
    passengerText: {
        display: 'flex',
        alignItems: 'center'
    },
    paxCounterContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 'fit-content',
        border: `1px solid ${theme.palette.primary.light}`,
        borderRadius: theme.spacing(2),
        width: 130
    },
    paxCount: {
        padding: theme.spacing(0, 2),
        backgroundColor: theme.palette.primary.light
    },
    flexDirectionColumnWithGap5pxWithoutPadding: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px'
    },
    greyTextIcon: {
        color: THEME_WEBSITE_GREY_COLOR
    }
}));

export default useStyles;
